{
  "list": {
    "title": "Cursanți",
    "addStudent": "Adaugă cursant",
    "searchLabel": "Caută",
    "searchPlaceholder": "Caută după nume sau e-mail…",
    "allStatuses": "Toate statuturile",
    "cols": {
      "name": "Nume",
      "email": "E-mail",
      "status": "Statut",
      "tags": "Etichete"
    },
    "countOne": "{count} cursant",
    "countOther": "{count} cursanți",
    "prev": "Înapoi",
    "next": "Înainte",
    "pageOf": "Pagina {page} din {pages}"
  },
  "status": {
    "active": "Activ",
    "inactive": "Inactiv"
  },
  "create": {
    "sharePrompt": "Cursantul a fost creat și activat. Distribuie acest link de onboarding pentru ca el să accepte termenii și să își seteze o parolă:",
    "onboardingLinkAria": "Link de onboarding",
    "copy": "Copiază",
    "singleUseHint": "Linkul poate fi folosit o singură dată și expiră după finalizarea onboarding-ului.",
    "firstName": "Prenume",
    "lastName": "Nume",
    "email": "E-mail",
    "setActive": "Activează imediat",
    "activeHint": "Cursanții activi se pot autentifica imediat în portal. Linkul de onboarding va fi afișat aici după creare.",
    "done": "Gata",
    "create": "Creează",
    "required": "Prenumele, numele și e-mailul sunt obligatorii"
  },
  "toast": {
    "created": "Cursant creat",
    "createFailed": "Crearea cursantului a eșuat",
    "linkCopied": "Link copiat",
    "copyFailed": "Copierea a eșuat — selectează linkul manual",
    "linkRegenerated": "Link de onboarding regenerat",
    "tierUpdated": "Nivel de preț actualizat",
    "invalidOverride": "Introdu o sumă nenegativă sau lasă necompletat pentru a șterge",
    "overrideCleared": "Suprascriere ștearsă",
    "overrideSaved": "Suprascriere salvată",
    "paymentsGenerated": "{count} plăți generate",
    "chooseMethod": "Alege o metodă de plată",
    "paymentRecorded": "Plată înregistrată",
    "invalidCredit": "Introdu o sumă de credit pozitivă",
    "creditIssued": "Credit acordat",
    "levelUpdated": "Nivel actualizat",
    "enrolled": "Înscris"
  },
  "tabs": {
    "profile": "Profil",
    "classes": "Clase",
    "levels": "Niveluri",
    "payments": "Plăți",
    "attendance": "Prezență"
  },
  "detail": {
    "deactivate": "Dezactivează",
    "activate": "Activează",
    "resetPassword": "Resetează parola",
    "addTagPlaceholder": "Adaugă etichetă…",
    "onboardingLink": "Link de onboarding:",
    "gdpr": {
      "title": "Date și confidențialitate (GDPR)",
      "lede": "Exportă toate datele cursantului la cerere sau șterge datele personale, păstrând înregistrările financiare cerute de lege.",
      "badge": "Anonimizat",
      "export": "Exportă datele",
      "exporting": "Se pregătește…",
      "exportStarted": "Export descărcat",
      "erase": "Șterge datele personale",
      "erasing": "Se șterge…",
      "erased": "Datele personale au fost șterse",
      "alreadyErased": "Datele personale au fost șterse pe {date}.",
      "eraseTitle": "Șterge datele personale",
      "eraseWarning": "Această acțiune anonimizează definitiv pe {name}. Nu poate fi anulată.",
      "bulletAnonymize": "Numele, datele de contact și toate câmpurile personale sunt șterse; contul este dezactivat.",
      "bulletMedia": "Fișierele încărcate (poza de profil, elemente din galerie) sunt șterse din stocare.",
      "bulletFinancials": "Înregistrările de plăți și contabilitate sunt păstrate, dar legate de o identitate anonimizată.",
      "confirmLabel": "Scrie DELETE pentru a confirma",
      "eraseConfirmBtn": "Șterge datele"
    },
    "fields": {
      "email": "E-mail",
      "phone": "Telefon",
      "dob": "Data nașterii",
      "gender": "Gen",
      "address": "Adresă",
      "guardian": "Tutore",
      "statusNotes": "Note despre statut",
      "contractAccepted": "Contract acceptat"
    },
    "yes": "Da",
    "no": "Nu",
    "classes": {
      "enrollLabel": "Înscrie la clasă",
      "selectPlaceholder": "Selectează o clasă…",
      "enroll": "Înscrie",
      "colClass": "Clasă",
      "colTeacher": "Profesor",
      "colDay": "Zi",
      "colTime": "Oră",
      "empty": "Nu este înscris la nicio clasă"
    },
    "levels": {
      "levelLabel": "Nivel",
      "levelPlaceholder": "Nivel…",
      "danceTypeLabel": "Tip de dans",
      "danceTypePlaceholder": "Tip…",
      "assignUpdate": "Atribuie / Actualizează",
      "empty": "Niciun nivel atribuit încă"
    },
    "payments": {
      "pricingFees": "Prețuri și taxe",
      "priceTier": "Nivel de preț",
      "assignFee": "Atribuie o taxă",
      "chooseFee": "Alege o taxă…",
      "colFee": "Taxă",
      "colType": "Tip",
      "colAmount": "Sumă",
      "overrideTag": "(suprascris)",
      "override": "Suprascrie",
      "remove": "Elimină",
      "noFees": "Nicio taxă atribuită",
      "generateMonth": "Generează luna curentă",
      "colDue": "Scadent",
      "colMethod": "Metodă",
      "colStatus": "Statut",
      "creditTag": "({amount} credit)",
      "noPaymentsHeading": "Nicio plată încă",
      "noPaymentsMessage": "Atribuie o taxă, apoi generează plățile lunii curente.",
      "record": "Înregistrează"
    },
    "credit": {
      "title": "Credit",
      "balanceLabel": "Sold:",
      "autoApplied": "aplicat automat la înregistrarea plăților.",
      "hideDetails": "Ascunde detaliile",
      "showDetails": "Arată detaliile",
      "colDate": "Dată",
      "colActivity": "Activitate",
      "colDetail": "Detaliu",
      "colAmount": "Sumă",
      "added": "Adăugat",
      "used": "Folosit",
      "issueLabel": "Acordă credit",
      "amountPlaceholder": "Sumă",
      "noteLabel": "Notă",
      "notePlaceholder": "ex. rambursare, gest de bunăvoință",
      "addCredit": "Adaugă credit",
      "paymentDefault": "Plată"
    },
    "attendance": {
      "colDate": "Dată",
      "colClass": "Clasă",
      "colStatus": "Statut",
      "empty": "Niciun record de prezență încă"
    },
    "override": {
      "customPrice": "Preț personalizat pentru",
      "default": "· implicit {amount}",
      "amountLabel": "Sumă suprascrisă ({currency})",
      "amountPlaceholder": "necompletat = folosește prețul nivelului",
      "noteLabel": "Notă (opțional)",
      "notePlaceholder": "ex. tarif redus",
      "clearHint": "Lasă suma necompletată și salvează pentru a elimina suprascrierea și a reveni la prețul stabilit de nivel."
    },
    "record": {
      "title": "Înregistrează plata",
      "creditWillApply": "({amount} credit se va aplica)",
      "paidVia": "Plătit prin",
      "methodDefault": "{name} (implicit)",
      "referenceLabel": "Referință (opțional)",
      "referencePlaceholder": "ex. ref. transfer / nr. chitanță",
      "notesLabel": "Note (opțional)",
      "noMethods": "Nicio metodă de plată activă — adaugă una în Setări → Facturare."
    }
  }
}
